import React from 'react'

export function Close(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width='35'
      height='35'
      viewBox='0 0 35 35'
    >
      <defs>
        <style>
          {
            '.close-a,.close-b{fill:none;}.close-a,.close-d{clip-rule:evenodd;}.close-c,.close-d{fill:#c40000;}.close-e{fill:rgba(255,255,255,0);}.close-f{clip-path:url(#close-a);}.close-g{clip-path:url(#close-b);}.close-h{clip-path:url(#close-c);}.close-i{clip-path:url(#close-d);}.close-j{clip-path:url(#close-e);}.close-k{clip-path:url(#close-f);}.close-l{fill:#fff;}'
          }
        </style>
        <clipPath id='close-a'>
          <path className='close-a' d='M9.856-.287H0V-20H19.712V-.287Z' />
        </clipPath>
        <clipPath id='close-b'>
          <path className='close-b' d='M-1365,805H435V-796H-1365Z' />
        </clipPath>
        <clipPath id='close-c'>
          <rect
            className='close-c'
            width='20'
            height='20'
            transform='translate(0 -20)'
          />
        </clipPath>
        <clipPath id='close-d'>
          <path
            className='close-d'
            d='M19.712-5.445A5.158,5.158,0,0,1,14.557-.287h-9.4A5.158,5.158,0,0,1,0-5.445v-9.4A5.159,5.159,0,0,1,5.155-20h9.4a5.159,5.159,0,0,1,5.156,5.159Z'
          />
        </clipPath>
        <clipPath id='close-e'>
          <path className='close-c' d='M0,0H20V-20H0Z' />
        </clipPath>
        <clipPath id='close-f'>
          <path
            className='close-a'
            d='M8.574-5.036v-3.8H4.751v-2.621H8.574v-3.8h2.553v3.8h3.836v2.621H11.127v3.8Z'
          />
        </clipPath>
      </defs>
      <path className='close-e' d='M0,0H35V35H0Z' />
      <g transform='translate(8 28)'>
        <g className='close-f'>
          <g className='close-g'>
            <g className='close-h'>
              <g className='close-i'>
                <g className='close-j'>
                  <path className='close-c' d='M-5,4.713H24.712V-25H-5Z' />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g className='close-k' transform='translate(10.06 3.999) rotate(-45)'>
          <g className='close-g'>
            <path className='close-l' d='M-.249-.036H19.963V-20.251H-.249Z' />
          </g>
        </g>
      </g>
    </svg>
  )
}
